(function () {
    'use strict';

    /**
     * @ngdoc service
     * @name manageRoles.factory:ManageRolesRequestFactory
     *
     * @description
     *
     */
    angular
        .module('manageRoles')
        .factory('ManageRolesRequestFactory', ManageRolesRequestFactory);

    function ManageRolesRequestFactory(ManageRolesAdaptorFactory) {

        function RolesSearchDTO() {
            this.roleName = null;
            this.pageSize = null;
            this.startPosition = null;
            this.status = null;
        }

        function SaveRoleRequest() {
            this.name = null;
            this.status = null;
            this.visibility = null;
            this.remarks = null;
            this.privileges = [];
            this.roleId = null;
            this.version = null;
        }

        function SearchCriteriaDTO() {

        }

        function DeleteRoleRequest() {
            this.roleId = null;
            this.version = null;
        }

        function GetRolesSearchCriteria() {
            return new RolesSearchDTO();
        }

        function GetRolesSearchRequest() {
            return new new SearchCriteriaDTO();
        }

        function GetRoleForSave(role) {
            var saveRole = new SaveRoleRequest();
            saveRole.name = role.name;//price.airportCode && price.airportCode.airPortCode;
            saveRole.status = role.roleStatus || role.status;
            saveRole.visibility = role.roleVisibility || role.visibility;
            saveRole.remarks = role.remarks || role.roleRemarks;
            saveRole.privileges = ManageRolesAdaptorFactory.reAdaptPrivileges(role.privileges || role.priviList);
            saveRole.roleId = role.roleId;
            saveRole.version = role.version;
            return saveRole;
        }

        function GetRoleDeleteReq(role) {
            var new_Role = new DeleteRoleRequest();
            new_Role.roleId = role.roleId;
            new_Role.version = role.version;
            return new_Role;
        }

        function GetRoleSaveReq() {
            return new SaveRoleRequest();
        }

        function RoleDTO() {
            this.name = null;
            this.status = null;
            this.visibility = null;
            this.remarks = null;
            this.privileges = [];
            this.roleId = null;
            this.version = null;
        }

        function GetNewRole() {
            var role = new RoleDTO();
            role.version = -1;
            role.statusCode = "INA";
            role.status = true;
            return role;
        }

        return {
            getRolesSearchCriteria: GetRolesSearchCriteria,
            getRolesSearchRequest: GetRolesSearchRequest,
            getRoleForSave: GetRoleForSave,
            getRoleDeleteReq: GetRoleDeleteReq,
            getRoleSaveReq: GetRoleSaveReq,
            getNewRole: GetNewRole
        }
    }
})();